import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { fetchKpiWeights, saveKpiWeights } from "../../api/kpi";

const KEYS = ["attendance", "punctuality", "duties", "absence", "tasks"];

// أوزان الدرجة الأساسية — الأدمن فقط، وتُطبَّع إلى 100% في الخادم.
export const KpiWeights = ({ canEdit, onSaved }) => {
  const { t } = useTranslation();
  const [weights, setWeights] = useState(null);

  useEffect(() => {
    fetchKpiWeights().then((d) => setWeights(d.weights)).catch(() => setWeights(null));
  }, []);

  if (!weights) return null;
  const save = async () => {
    const data = await saveKpiWeights(Object.fromEntries(KEYS.map((k) => [k, Number(weights[k]) || 0])));
    setWeights(data.weights);
    toast.success(t("kpi.weightsSaved"));
    onSaved?.();
  };

  return (
    <NeuCard className="grid gap-3 p-4" data-testid="kpi-weights">
      <p className="label-xs">{t("kpi.weightsTitle")}</p>
      <div className="grid gap-3 sm:grid-cols-5">
        {KEYS.map((key) => (
          <label key={key} className="grid gap-1 text-xs font-bold">
            {t(`kpi.parts.${key}`)}
            <NeuInput type="number" min="0" max="100" data-testid={`kpi-weight-${key}`}
                      disabled={!canEdit} value={weights[key]}
                      onChange={(e) => setWeights({ ...weights, [key]: e.target.value })} />
          </label>
        ))}
      </div>
      {canEdit ? (
        <NeuButton variant="primary" className="w-fit px-4 py-2 text-xs" data-testid="kpi-weights-save"
                   onClick={save}>
          {t("kpi.saveWeights")}
        </NeuButton>
      ) : null}
    </NeuCard>
  );
};
